export default "__VITE_ASSET__Cgb9NZG1__"